export const Fila1 = [
    {
        id: 0,
        nombre: "Marketing Digital y Redes Sociales"
    },
    {
        id: 1,
        nombre: "Community Manager"
    },
    {
        id: 2,
        nombre: "Dibujo y Pintura Artística"
    },
    {
        id: 3,
        nombre: "Curso Patronaje/Confección y Transformación de Prendas"
    },
    {
        id: 4,
        nombre: "Suite Adobe (Illustrator- Phostoshop- Indesign)"
    },
    {
        id: 5,
        nombre: "AutoCAD Bidimensional"
    }
];

export const Fila2 = [
    {
        id: 0,
        nombre: "Marketing para Emprendedores"
    },
    {
        id: 1,
        nombre: "Seo Básico"
    },
    {
        id: 2,
        nombre: "Patronaje y Confección Básico"
    },
    {
        id: 3,
        nombre: "Patronaje Digital (OPTITEX)"
    },
    {
        id: 4,
        nombre: "After Effects"
    },
    {
        id: 5,
        nombre: "Oratoria, Voz y Dicción"
    }
];


// WEBPACK FOOTER //
// ./src/shared/ExtensionItems.jsx